// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kV6m","label":"styles_label__2pl37"};